import React from 'react';
import Debug from 'debug';

import monitor from 'lib/utils/monitor';

const debug = Debug('rs:components/App/withMonitor');

function withMonitor(App) {
  debug('initializing');

  return class WrappedComponent extends React.Component {
    static async getInitialProps(params) {
      debug('get initial props');
      const { req } = params.ctx;

      // Call the descendant getInitialProps() chain and catch
      // any exceptions that may happen further down. This reporting
      // is here instead of `pages/_error` to be able to add (redux)
      // page specific state to the Sentry error payload in the future.
      try {
        return App.getInitialProps ? await App.getInitialProps(params) : {};
      } catch (err) {
        debug('caught error');
        // TODO: find a way to get current redux state
        // to pass as metadata to monitor to aide diagnosis.
        monitor.error(err, {
          req,
          tags: { from: 'WithMonitorGetInitialProps' },
        });
        throw err;
      }
    }

    render() {
      return <App {...this.props} />;
    }
  };
}

export default withMonitor;
